import { isServiceUnavailableError } from "~/lib/platform/retry"

// Why adding a bot/agent to a group failed, in words a user can act on. Tauri commands reject with
// the server's text as a plain string (commands/*.rs → grpc_error), not an Error, so `e.message`
// alone loses it. Known server texts (Bots validators, GroupActor.JoinByForce, UserBotActor) are
// rephrased; anything else is shown as the server wrote it - backend rejections are Russian by
// convention (RequestRejectedException).

/** The raw text of whatever `invoke` rejected with. */
export function errorText(error: unknown): string {
  if (error instanceof Error) return error.message
  if (typeof error === "string") return error
  if (error && typeof error === "object" && "message" in error) return String((error as { message: unknown }).message)
  return ""
}

const KNOWN: { pattern: RegExp, message: string }[] = [
  {
    // The server's Permissions enum is older than the client's: it doesn't know some picked bits
    // (e.g. the board permissions, bits 40-45).
    pattern: /неизвестные биты|не поддерживает некоторые/i,
    message: "Сервер пока не поддерживает некоторые из выбранных прав (например, права досок). Снимите их и попробуйте снова.",
  },
  { pattern: /уже состоит/i, message: "Этот бот уже состоит в выбранной группе." },
  { pattern: /только администраторы|создатель группы/i, message: "Добавлять ботов могут только администраторы и создатель группы." },
  { pattern: /только участники/i, message: "Вы не состоите в этой группе." },
  { pattern: /группа не найдена/i, message: "Группа не найдена — возможно, её удалили." },
  { pattern: /bot not found|бот не найден/i, message: "Бот не найден — возможно, его удалили." },
  { pattern: /timed out|deadline/i, message: "Сервер не ответил вовремя. Попробуйте ещё раз." },
  { pattern: /internal server error/i, message: "На сервере произошла ошибка. Попробуйте ещё раз позже." },
]

export function addBotToGroupErrorMessage(error: unknown): string {
  if (isServiceUnavailableError(error)) return error.message
  const text = errorText(error).replace(/^\[transient:[A-Z_]+\]\s*/, "").trim()
  const known = KNOWN.find((k) => k.pattern.test(text))
  if (known) return known.message
  return text || "Неизвестная ошибка. Попробуйте ещё раз."
}
